import React, { PureComponent } from 'react';

import FeedPollItemOption from './components/FeedPollItemOption';
import { timeLeft } from '../../../utils/helpers';
import { logFirebaseEvent } from '../../../firebase/analytics';
import { Link } from 'react-router-dom';
import { TranslateApi } from '../../../api';

class FeedPollItem extends PureComponent {
  constructor(props) {
    super(props);

    this.helperTimeLeftToVote = timeLeft(props.item.post.expiry_date);

    this.state = {
      isTranslated: false,
      question: props.item.post.question,
      options: props.item.post.options,
      timeLeftToVote: this.helperTimeLeftToVote,
      showAsFinished: !this.helperTimeLeftToVote || !!props.item.post.my_vote_id
    }
  }

  _vote = optionId => {
    if (this.props.disableVote) return;
    logFirebaseEvent({
      event: 'poll',
      action: 'vote',
    });
    this.props.voteOnPost(optionId);
  };
  parseQuestion = questionTxt => {
    let reg = /@\[([^\]]+?)]\(id:([^\]]+?)\)/;
    const parts = [];

    let left = questionTxt || '';
    while (left !== '') {
      let matched = false;
      const match = reg.exec(left);
      if (match) {
        matched = true;
        parts.push(left.substr(0, match.index));
        parts.push(
          <Link
            className='feed-item-footer-comment-owner'
            key={match[2]}
            to={
              this.props.myGroups && this.props.myGroups.indexOf(match[2]) !== -1
                ? `/group-feed/${match[2]}`
                : `/users/${match[2]}`
            }
          >
            {match[1]}
          </Link>,
        );
        left = left.substr(match.index + match[0].length);
      } else {
        parts.push(left.substr(0));
        left = '';
      }
    }
    return parts
  }

  onTranslateClicked = async () => {
    let translatedQuestion, translatedTimeLeft, translatedOptions;
    const { question, options, isTranslated, timeLeftToVote } = this.state

    this.setState({
      isTranslated: !isTranslated
    })

    if (isTranslated) {
      this.setState({
        question: this.props.item.post.question,
        options: this.props.item.post.options,
        timeLeftToVote: this.translatedTimeLeft
      })

      return null
    }

    if (this?.props?.currentUser?.language_id) {
      const resultQuestion = await TranslateApi.getTranslation(this.props.currentUser.language_id, question)
      if (resultQuestion && resultQuestion.success) {
        translatedQuestion = resultQuestion.data
      }

      const resultTimeLeft = await TranslateApi.getTranslation(this.props.currentUser.language_id, timeLeftToVote)
      if (resultTimeLeft && resultTimeLeft.success) {
        translatedTimeLeft = resultTimeLeft.data
      }

      translatedOptions=JSON.parse(JSON.stringify(options));
      for (let optionIndex = 0; optionIndex < translatedOptions.length; optionIndex++) {
        const data = translatedOptions[optionIndex]

        const resultOptions = await TranslateApi.getTranslation(this.props.currentUser.language_id, data.option_text)
        if (resultOptions && resultOptions.success) {
          translatedOptions[optionIndex].option_text = resultOptions.data
        }
      }
    
      if (!translatedQuestion ) {
        this.props.addAlertToAlerts({
          title: 'Message',
          message: 'Translation to your selected language is not currently available.',
          confirmBtnText: 'Okay',
        });
      } else {
        this.setState({
          question: translatedQuestion,
          options: translatedOptions,
          timeLeftToVote: translatedTimeLeft
        })
      }
    } else {
      this.props.addAlertToAlerts({
        title: 'Message',
        message: 'User does not have a language configured.',
        confirmBtnText: 'Okay',
      });
    }
  }

  render() {
    const { question, options, timeLeftToVote, showAsFinished } = this.state
    const { item } = this.props;
    const totalVotes = item.post.options.reduce((sum, item) => sum + item.total_votes, 0);
    return (
      <div className="feed-item-content">
        {this.parseQuestion(question)}

        <div className="d-flex flex-wrap feed-item-content-poll">
          {options.map(option => {
            return (
              <FeedPollItemOption
                key={`options:${option.id}`}
                text={option.option_text}
                isSelected={option.selected}
                onClick={() => this._vote(option.id)}
                showAsFinished={showAsFinished}
                votes={option.total_votes}
                percents={(option.total_votes * 100) / totalVotes}
              />
            );
          })}
        </div>

        <p className="feed-item-content-poll-total">
          {timeLeftToVote
            ? `${totalVotes} vote${totalVotes === 1 ? '' : 's'} with ${timeLeftToVote}`
            : `Poll ended with ${totalVotes} vote${totalVotes === 1 ? '' : 's'}`}
        </p>
        <div className="feed-item-footer" style={{cursor: 'pointer', position: 'absolute', right: 25, paddingTop: 20}} onClick={this.onTranslateClicked}>
            <p>{`${this.state.isTranslated ? "Show original" : "Translate this"}`}</p>
          </div>
      </div>
    );
  }
}

export default FeedPollItem;
